var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isNullOrUndefined } from 'util';
import FetchSettingsFactory from './fetchSettingsFactory';
import moment from "moment";
var ServiceBase = /** @class */ (function () {
    function ServiceBase() {
        this.factory = new FetchSettingsFactory();
    }
    ServiceBase.prototype.fetchApi = function (url, init, timeout, skipSessionCheck) {
        if (timeout === void 0) { timeout = null; }
        if (skipSessionCheck === void 0) { skipSessionCheck = false; }
        return __awaiter(this, void 0, Promise, function () {
            var fetchUrl, timeoutPromise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!skipSessionCheck)
                            this.checkSessionExpiration();
                        fetchUrl = this.getFetchUrl(url);
                        if (!(timeout !== null)) return [3 /*break*/, 1];
                        timeoutPromise = new Promise(function (resolve, reject) {
                            var id = setTimeout(function () {
                                clearTimeout(id);
                                reject('Timed out in ' + timeout + 'ms.');
                            }, timeout);
                        });
                        // Returns a race between our timeout and the passed in promise
                        return [2 /*return*/, Promise.race([
                                fetch(fetchUrl, init),
                                timeoutPromise
                            ])];
                    case 1: return [4 /*yield*/, fetch(fetchUrl, init)];
                    case 2: 
                    // Default functionality
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ServiceBase.prototype.checkSessionExpiration = function () {
        var expired = this.checkSessionExpiringSoon(0);
        if (expired == true && !window.location.href.endsWith("sessionExpired")) {
            var addr = "/sessionExpired";
            window.location.href = addr;
        }
        return expired;
    };
    ServiceBase.prototype.checkSessionExpiringSoon = function (mins) {
        var sessionExpiration = decodeURIComponent(document.cookie.replace(/(?:(?:^|.*;\s*)SessionExpires\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
        var expired = false;
        if (isNullOrUndefined(sessionExpiration) || sessionExpiration == "") {
            //SessionExpires cookie has expired or was deleted by user
            expired = true;
        }
        else {
            var expirationDate = moment(sessionExpiration);
            var date = moment(Date.now()).add(mins, 'minutes');
            if (date > expirationDate) {
                expired = true;
            }
        }
        return expired;
    };
    ServiceBase.prototype.getServedUrl = function (url) {
        return this.getFetchUrl(url);
    };
    ServiceBase.prototype.getFetchUrl = function (url) {
        var tempUrl = (url || "").trim();
        if (tempUrl.length > 0) {
            // "/" or "" 
            var prefix = this.getUrlPrefix(tempUrl);
            // Api url without the leading "/" character
            var relativeApiUrl = this.getRelativeApiUrl(tempUrl);
            // api/test => prefix = "" , url = "api/test"
            // v dir = "a" | v dir = ""
            // result should be a/api/test | api/test
            // 
            // /api/test => prefix = "/" , url = "api/test"
            // v dir = "a" | v dir = ""
            // result should be /a/api/test | /api/test
            tempUrl = prefix + relativeApiUrl;
        }
        return tempUrl;
    };
    ServiceBase.prototype.getUrlPrefix = function (url) {
        var prefix = "";
        if (url && url.length > 0 && url.startsWith("/")) {
            prefix = url[0];
        }
        return prefix;
    };
    ServiceBase.prototype.getRelativeApiUrl = function (url) {
        var relativeApiUrl = url;
        if (url && url.length > 0 && url.startsWith("/")) {
            relativeApiUrl = url.substring(1);
        }
        return relativeApiUrl;
    };
    return ServiceBase;
}());
export default ServiceBase;
